/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legal_Travel_Landing_TitleInputs */

const en_service_legal_travel_landing_title = /** @type {(inputs: Service_Legal_Travel_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Help Wherever You Are`)
};

const fr_service_legal_travel_landing_title = /** @type {(inputs: Service_Legal_Travel_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide juridique où que vous soyez`)
};

/**
* | output |
* | --- |
* | "Legal Help Wherever You Are" |
*
* @param {Service_Legal_Travel_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legal_travel_landing_title = /** @type {((inputs?: Service_Legal_Travel_Landing_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legal_Travel_Landing_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legal_travel_landing_title(inputs)
	return fr_service_legal_travel_landing_title(inputs)
});